import { MouseEvent, useState } from 'react'
import { GridColDef } from '@microservices/wiskey-react-table-component'

import { NestedMenuProps } from '@components/NestedMenu'
import { VariableValue } from '@components/Variables/types'

import { ExecutionContext, getValuesFromVariables } from '@helpers'
import { BIND_TYPE } from '@constants'
import { ObjectDataRecord } from '@types'

export const useContextMenuHandlers = (
  columns: GridColDef<ObjectDataRecord>[],
  configActions: any,
  apiRef: any,
  onOpenContextMenu: (event: MouseEvent<HTMLDivElement>) => void,
  executionContext?: ExecutionContext,
  outerVariables?: VariableValue[]
) => {
  const [contextMenuData, setContextMenuData] = useState<Omit<NestedMenuProps, 'onClose'>>({
    items: [],
    dataTransfer: {
      changes: {},
      config: {},
      data: {},
      metaData: {},
    },
    onItemClick: undefined,
  })

  const handleContextMenu = (event: MouseEvent<HTMLDivElement>) => {
    const field = event.target?.dataset?.field ?? ''
    const column = columns.find(col => col.field === field)

    if (!field || column?.bindType === BIND_TYPE.ACTION) {
      return
    }

    const rowId = event.currentTarget.getAttribute('data-id')
    const columnId = column?.id

    const commonSrcObj = {
      ...apiRef.current.getRow(rowId),
      outerVariables: getValuesFromVariables(outerVariables),
      outerVariablesForInnerAction: outerVariables,
    }

    if (columnId && configActions.actionsAvailable.on_column_right_click?.[columnId]) {
      event.preventDefault()

      setContextMenuData({
        items: configActions.actionsData.on_column_right_click[columnId]?.contextMenu?.menuPoints,
        dataTransfer: {
          changes: {},
          config: {},
          data: {},
          metaData: {
            column,
            srcObj: {
              ...commonSrcObj,
              variables:
                configActions.actionsData.on_column_right_click[columnId]?.contextMenu
                  ?.staticVariables,
            },
            ...executionContext,
          },
        },
        onItemClick: configActions.actionHandlers.on_column_right_click[columnId],
      })
      onOpenContextMenu(event)

      return
    }

    if (configActions.actionsAvailable.on_row_right_click && rowId) {
      event.preventDefault()

      const rowId = event.currentTarget.getAttribute('data-id')

      if (rowId) {
        setContextMenuData({
          items: configActions.actionsData.on_row_right_click?.contextMenu?.menuPoints,
          dataTransfer: {
            changes: {},
            config: {},
            data: {},
            metaData: {
              srcObj: {
                ...commonSrcObj,
                variables:
                  configActions.actionsData.on_row_right_click?.contextMenu?.staticVariables,
              },
              ...executionContext,
            },
          },
          onItemClick: configActions.actionHandlers.on_row_right_click,
        })
        onOpenContextMenu(event)
      }
    }
  }

  return {
    contextMenuData,
    handleContextMenu,
  }
}
